import SocialNetworks from './SocialNetworks'

export default SocialNetworks



// WEBPACK FOOTER //
// ./src/components/shared/elements/SocialNetworks/index.js